import { define, html } from "hybrids";

export interface VBroadcastSponsorLogo {
  src: string;
  alt: string;
}

export default define<VBroadcastSponsorLogo>({
  tag: "v-broadcast-sponsor-logo",
  src: "",
  alt: "",
  render: ({ src, alt }) => html`<img src="${src}" alt="${alt}" />`.css`
    :host {
      display: flex;
      border-radius: 2px;
      overflow: hidden;
      -webkit-mask-image: -webkit-radial-gradient(white, black);
    }

    img {
      max-width: 150px;
      max-height: 60px;
      object-fit: contain;
      display: block;
    }
  `,
});
